// src/pages/AboutUs.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import aboutImg from '../assets/images/aboutImg.jpg'

const AnimatedSection = ({ children, className = '' }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ y: 60, opacity: 0 }}
      animate={inView ? { y: 0, opacity: 1 } : {}}
      transition={{ duration: 0.8 }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

const AboutUs = () => {
  return (
    <div className="max-w-6xl xl:max-w-7xl 2xl:max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      {/* Header 
      <AnimatedSection className="text-center mb-16 lg:mb-24">
        <h1 className="text-4xl xs:text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-800 mb-6 lg:mb-8">
          About Us
        </h1>
        <p className="text-xl sm:text-2xl lg:text-3xl text-gray-600 max-w-4xl xl:max-w-5xl mx-auto leading-relaxed">
          Transforming lives through educational opportunities since 2010. 
          We believe in the power of education to break cycles of poverty and create lasting change.
        </p>
      </AnimatedSection>
*/}
      {/* Our Story */}
      <AnimatedSection className="mb-20 lg:mb-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 xl:gap-20 items-center">
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-6 lg:mb-8">SUPPORTING YOUTH EDUCATION FOR A BETTER FUTURE.</h2>
            <div className="space-y-4 lg:space-y-6 text-start text-gray-600 text-lg lg:text-xl leading-relaxed">
              <p>The M.A. Seidu Education Fund is intended to preserve the memory of the late Mr. M.A. Seidu, former Headmaster of now Wa Senior High School, Regional Director of Education and Proprietor of Dan-Ibu International School. Mr. M.A. Seidu served three terms as MP for Wa Central, during which time he was Deputy Minority Whip and Minister of State at the Presidency.
              </p>
              <p>The M.A. Seidu Education Fund aims primarily to provide financial support and mentorship to needy but brilliant students in the Upper West Region to enter and complete Senior High School successfully.
              </p>
            </div>
          </div>
         <motion.div
  whileHover={{ scale: 1.05 }}
  transition={{ duration: 0.4 }}
  className="relative overflow-hidden rounded-2xl lg:rounded-3xl shadow-2xl bg-gradient-to-br from-red-500 to-blue-600 
             h-64 sm:h-80 md:h-96 lg:h-[500px] xl:h-[560px] 
             flex items-center justify-center"
>
  <img
    src={aboutImg}
    alt="M.A. Seidu Education Fund - Supporting Youth Education"
    className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 hover:scale-110"
  />
  
  {/* Optional: Dark overlay for better text contrast if you ever add text on top */}
  <div className="absolute inset-0 bg-black/20"></div>
  
  {/* Optional: Subtle caption or logo overlay (uncomment if needed) */}
  {/* <div className="relative z-10 text-white text-center px-8">
    <p className="text-lg sm:text-xl lg:text-2xl font-medium tracking-wide">
      Empowering the Next Generation
    </p>
  </div> */}
</motion.div>
        </div>
      </AnimatedSection>

      {/* Impact Stats 
      <AnimatedSection className="bg-gradient-primary text-white rounded-2xl lg:rounded-3xl p-8 lg:p-12 xl:p-16 mb-20 lg:mb-32 shadow-2xl">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 xl:gap-12 text-center">
          {[
            { number: '5,000+', label: 'Students Supported', icon: '👨‍🎓' },
            { number: '$50M+', label: 'Funds Disbursed', icon: '💰' },
            { number: '95%', label: 'Graduation Rate', icon: '🎓' },
            { number: '50+', label: 'Partner Institutions', icon: '🏫' },
          ].map((stat, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.1 }}
              className="p-4 lg:p-6"
            >
              <div className="text-3xl mb-2">{stat.icon}</div>
              <div className="text-2xl lg:text-3xl xl:text-4xl font-bold mb-2 lg:mb-4">{stat.number}</div>
              <div className="text-blue-100 text-sm lg:text-base xl:text-lg">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </AnimatedSection>
*/}
      {/* Team Approach
      <AnimatedSection className="text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-8 lg:mb-16">Our Approach</h2>
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {[
            {
              step: '01',
              title: 'Identify Talent',
              description: 'We identify promising students through rigorous selection processes and community partnerships.',
              icon: '🔍'
            },
            {
              step: '02',
              title: 'Provide Funding',
              description: 'Comprehensive financial support covering all educational expenses and personal development needs.',
              icon: '💸'
            },
            {
              step: '03',
              title: 'Mentor & Guide',
              description: 'Ongoing mentorship, career guidance, and personal support throughout the educational journey.',
              icon: '🎯'
            }
          ].map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -10 }}
              className="bg-white p-6 lg:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="text-4xl lg:text-5xl mb-4">{item.icon}</div>
              <div className="text-2xl lg:text-3xl font-bold text-blue-600 mb-2">{item.step}</div>
              <h3 className="text-xl lg:text-2xl font-semibold mb-4 lg:mb-6 text-gray-800">{item.title}</h3>
              <p className="text-gray-600 text-base lg:text-lg leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </AnimatedSection>
       */}
    </div>
  );
};

export default AboutUs;